import { Box, Heading, type HeadingProps, Stack, Text, VStack } from '@chakra-ui/react'

const MAX_W = '800px'

export type Step = {
  key: string
  name: string | (() => JSX.Element)
  description?: string | (() => JSX.Element)
}

export default function NumberedSteps({
  title = null,
  steps,
  numberStyle = { fontWeight: 900, color: 'gray.subtle' },
  align = 'left',
}: {
  title?: string | (() => JSX.Element) | null
  steps: Step[]
  numberStyle?: HeadingProps
  align?: 'left' | 'center'
}): JSX.Element {
  return (
    <Box>
      {title != null ? (
        <Box mb="64px">
          {typeof title === 'string' ? (
            <Heading size="2xl" textAlign={align}>
              {title}
            </Heading>
          ) : (
            title()
          )}
        </Box>
      ) : null}
      <Stack direction="column" maxWidth={MAX_W} spacing="32px" align={align}>
        {steps.map(({ key, name, description = null }, index) => (
          <Stack key={key} direction="row" align="center" width="100%">
            <Heading fontSize="80px" minWidth={['48px', '80px']} {...numberStyle}>
              {index + 1}
            </Heading>
            <VStack gap="16px">
              {typeof name === 'string' ? (
                <Heading size="lg" as="h4">
                  {name}
                </Heading>
              ) : (
                name()
              )}
              {description != null ? (
                typeof description === 'string' ? (
                  <Text>{description}</Text>
                ) : (
                  description()
                )
              ) : null}
            </VStack>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}
